export default __webpack_public_path__ + "static/media/light-panel-outline.0e84b31f.png";